var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveTablet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 111,
    viewBox: "0 0 334 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.72 46.0286L0 73.8564V91C0 102.046 8.95431 111 20 111H304C320.569 111 334 97.5685 334 81V24.0817C332.783 23.3239 331.011 23.0707 330.259 23.0114C324.402 22.5495 321.043 26.9552 316.365 31.0386L316.307 31.0894C314.924 32.2975 311.465 35.3198 305.142 35.3198C298.73 35.3198 294.276 32.4657 292.851 31.0386L271.475 8.56238C268.625 5.70826 262.39 0 255.443 0C248.496 0 242.974 5.70826 240.48 8.56238L141.616 104.36C140.013 106.144 135.096 109.711 128.256 109.711C121.416 109.711 116.499 106.144 114.896 104.36L57.7152 43.3529C55.7557 41.2123 50.0198 36.9311 42.752 36.9311C35.4842 36.9311 29.0357 42.9961 26.72 46.0286Z",
    fill: "url(#paint0_linear_5_2750)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_2750",
    x1: 167,
    y1: -9.62686,
    x2: 167,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveTablet);
export default __webpack_public_path__ + "static/media/wave-tablet.af2ed23a413e624fb6007f53811c7e50.svg";
export { ForwardRef as ReactComponent };